namespace Areas.CollaborationAreas.Folders {
    "use strict";

    let selectedItem: any;
    let treeView: DevExpress.ui.dxTreeView;
    let attachmentGrid: DevExpress.ui.dxDataGrid;

    const CollaborationAreaFolderIdentifier = "CollaborationAreaFolderId";
    const AddButtonName = "AddCollaborationAreaFolder";
    const EditButtonName = "EditCollaborationAreaFolder";
    const DeleteButtonName = "DeleteCollaborationAreaFolder";

    $(() => { init(); });

    function init() {
        attachmentGrid = $("#attachmentDataGrid").dxDataGrid("instance");
        treeView = $("#CollaborationAreaFolderTree").dxTreeView("instance");
    }

    export function folderSelected(e: any) {
        selectedItem = e.node.itemData;

        disableButtons();

        if (location.href.toLowerCase().indexOf("edit") <0) {
            return;
        }

        if (isRootItem(selectedItem)) {
            Areas.enableButton(AddButtonName);
        } else {
            enableButtons();
        }

        applySelectedItemStyle(e);
        filterAttachmentGrid(selectedItem);
        updateUploadControl(selectedItem);
    }

    export function add() {
        const collaborationAreaId: any = treeView.option("CollaborationAreaId");

        const parameters = { 
            parentFolderName: selectedItem.text,
            data: { 
                collaborationAreaId: collaborationAreaId,
                name: "",
                parentId: selectedItem.id 
            } 
        };

        const dialog = new Areas.Dialogs.CreateCollaborationAreaFolder.CreateCollaborationAreaFolderDialog(
            dialogClosing, parameters);
    }

    function dialogClosing(dialogResult: DialogResult, data: any) {
        const dataGrid: any = $("#DailyReportTemplateGrid").dxDataGrid("instance");
        refreshTreeView();
    }

    export function edit() {
        const parameters = { 
            name: selectedItem.text,
            id: selectedItem.id 
        };

        const dialog = new Areas.Dialogs.EditCollaborationAreaFolder.EditCollaborationAreaFolderDialog(
            dialogClosing, parameters
        )
    }

    export function remove() {
        const confirmed = confirm("Are you sure you want to delete this folder?");

        if (!confirmed) return;

        sendRequest(`/CollaborationAreas/Folders/Delete/${selectedItem.id}`, null, "DELETE", () => refreshTreeView());
    }

    function refreshTreeView() {
        const source: any = treeView.option("dataSource");
        treeView.option("dataSource", source);
        attachmentGrid.clearFilter();
        selectedItem = null;
        disableButtons();
    }

    function disableButtons() {
        Areas.disableButton(AddButtonName);
        Areas.disableButton(EditButtonName);
        Areas.disableButton(DeleteButtonName);
    }

    function enableButtons() {
        Areas.enableButton(AddButtonName);
        Areas.enableButton(EditButtonName);
        Areas.enableButton(DeleteButtonName);
    }

    function isRootItem(item: any) {
        return item.id === -1;
    }

    function updateUploadControl(item: any) {
        const id = getId(item);

        const uploader = $("#fileUploaderControl").dxFileUploader("instance");

        if (uploader) {
            let url = uploader.option("uploadUrl");
            url = Areas.updateQueryStringParameter(url, CollaborationAreaFolderIdentifier, id);
            uploader.option("uploadUrl", url);            
        }
    }

    function filterAttachmentGrid(item: any) {
        const id = getId(item);
        attachmentGrid.clearFilter();
        attachmentGrid.filter([CollaborationAreaFolderIdentifier, "=", id]);
    }

    function getId(item: any) {
        return isRootItem(item) ? 0 : item.id;
    }

    function applySelectedItemStyle(e: any) {
        // The dxTreeView control does not persist the 'selected' style 
        // when it loses focus so a style must be manually applied to the selected item. 
        const selectedStyle = "treeview-selected-item";
        $(".dx-treeview-item").removeClass(selectedStyle);
        $(e.itemElement).addClass(selectedStyle);
    }
}